import { z } from 'zod';
import { zTagSelection } from '../core';
import { zWorkoutLayer } from './layer/edit';
export const zWorkoutTemplateCreate = z.object({
    id: z.uuid(),
    name: z.string(),
    tags: z.array(zTagSelection),
    template: zWorkoutLayer.array(),
    isMultiDay: z.boolean().optional(),
});
export const zWorkoutTemplateEdit = z.object({
    id: z.uuid(),
    name: z.string(),
    tags: z.array(zTagSelection),
    template: zWorkoutLayer.array().optional(),
    isMultiDay: z.boolean().optional(),
});
export const zWorkoutTemplateSearch = z.object({
    searchTerm: z.string().optional(),
    tagIds: z.array(z.uuid()).optional(),
    exerciseIds: z.array(z.uuid()).optional(),
    // exact match on the template array length (the day/workout count)
    workoutCount: z.number().int().positive().optional(),
    offset: z.number().optional(),
    limit: z.number().optional(),
});
//# sourceMappingURL=template-library.js.map